/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamItemAnswerTextCorrectionGridItemRepositoryResponse } from "../types/ExamItemAnswerTextCorrectionGridItemRepositoryResponse.ts";

export const examItemAnswerTextCorrectionGridItemRepositoryResponseSchema =
  z.object({
    id: z.optional(
      z.number().int().describe("ID do item da grade de correção."),
    ),
    label: z
      .string()
      .describe(
        "Rótulo da questão dissertativa exibido na grade de correção (pode conter HTML).",
      )
      .nullish(),
    labelClean: z
      .string()
      .describe(
        "Rótulo da questão dissertativa sem formatação HTML, utilizado para exibição simplificada.",
      )
      .nullish(),
    weight: z.optional(
      z
        .number()
        .int()
        .describe("Peso da questão dissertativa na composição da nota final."),
    ),
    correctionPendingCount: z.optional(
      z
        .number()
        .int()
        .describe(
          "Quantidade de respostas dissertativas pendentes de correção para esta questão.",
        ),
    ),
  }) as unknown as ToZod<ExamItemAnswerTextCorrectionGridItemRepositoryResponse>;
